<template>
  <div>
    <table>
      <thead>
        <tr v-if="!tableHeader">
          <th style="width: 15%">
            {{ $t('date') | uppercase }}
          </th>
          <th style="width: 17%">
            {{ $t('actionBy') | uppercase }}
          </th>
          <th>{{ $t('tenancy.history.category') | uppercase }}</th>
          <th style="width: 42%">
            {{ $t('tenancy.history.value') | uppercase }}
          </th>
        </tr>
        <tr v-else>
          <th
            v-for="head in tableHeader"
            :key="head"
            :style="{ width: head.width }"
          >
            {{ head.title | uppercase }}
          </th>
        </tr>
      </thead>
    </table>
    <div class="table-content">
      <table>
        <tbody>
          <template v-if="!tableHeader">
            <tr
              v-for="(item, index) in orderHistories"
              :key="index"
            >
              <td style="width: 15%">
                {{ item.createdAt | formatDate('DD MMM YY HH:mm:ss') }}
              </td>
              <td style="width: 17%">
                {{ item.who.displayName }}
              </td>
              <td>{{ contactCategoryTranslate(item.detail) | capitalize }}</td>
              <td style="width: 42%">
                <loopComponent :data="item.values" />
              </td>
            </tr>
          </template>
          <template v-else>
            <tr
              v-for="(item, index) in orderHistories"
              :key="index"
            >
              <td
                v-for="head in tableHeader"
                :key="head"
              >
                {{ getItemProperty(item, head.name) }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { getBySourceIdAndSourceTable } from '@/api/histories/request'
import EventBus from '@/utils/eventBus'
import { getFullnameSorts } from '@/utils/fullName'

const loopComponent = {
  name: 'loopComponent',
  template: `
  <div>
    <div v-for="(element, key, index) in sortedData" :key='key'>
      <div v-if="element && typeof(element) === 'object'">
        <label v-if="typeof key === 'string' ">{{key | capitalize}}:</label>
        <template v-else>
          <hr v-show="key !== 0"/>
        </template>
        <loopComponent style='display: inline-block;' :data='element' />
      </div>
      <span :title="element" style='word-break: break-all;' v-else>
        <span v-if="typeof key === 'string' ">
          {{ contactTypeTranslate(key) | capitalize }}:
        </span>
        <span v-else>
          {{key+1}}.
        </span>
        {{ contactValueTranslate(element, key) | isEmptyValue }}
      </span>
    </div>
  </div>
  `,
  props: {
    data: [Object, Array],
  },
  methods: {
    contactTypeTranslate (key) {
      switch (true) {
        case this.$te(`tenancy.history.contactType.${key.toLowerCase()}`):
          return this.$t(`tenancy.history.contactType.${key.toLowerCase()}`)
        case this.$te(`tenancy.history.contactType.${key}`):
          return this.$t(`tenancy.history.contactType.${key}`)
        default:
          return key
      }
    },
    contactValueTranslate (value, key) {
      const formatValue = typeof value === 'string' && value.toLowerCase().replace(/\.+$/, '')
      return this.$te(`company.contact.type.${formatValue}`)
        ? this.$t(`company.contact.type.${formatValue}`)
        : value
    },
  },
  computed: {
    emptyValue () {
      return this.$t('emptyValue')
    },
    sortedData () {
      if (typeof this.data === 'object' && !Array.isArray(this.data)) {
        const { firstName, lastName } = this.data
        if (firstName && lastName) {
          const obj = lodash.cloneDeep(this.data)
          delete obj.firstName
          delete obj.lastName
          return {
            ...getFullnameSorts().reduce((o, { label, value }) => {
              return { ...o, [label]: this.data[value] }
            }, { }),
            ...obj,
          }
        }
      }
      return this.data
    },
  },
}

export default {
  components: {
    loopComponent,
  },
  props: {
    sourceId: {
      type: [String, Number],
      default: undefined,
    },
    sourceTable: {
      type: String,
      default: null,
    },
    tableHeader: {
      type: Array,
      default: undefined,
    },
    rawHistories: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      histories: [],
    }
  },
  computed: {
    orderHistories () {
      const sourceHistories = lodash.isEmpty(this.rawHistories) ? this.histories : this.rawHistories
      return sourceHistories.map(item => {
        try {
          item.values = JSON.parse(item.detail.value)
        } catch (error) {
          item.values = item.detail.value
        }
        return item
      })
    },
  },
  async mounted () {
    if (this.sourceId) {
      await this.updateHistories()
    }
    EventBus.on('update_histories_table', this.updateHistories)
  },
  destroyed () {
    EventBus.off('update_histories_table', this.updateHistories)
  },
  methods: {
    getItemProperty (item, key) {
      return lodash.get(item, key)
    },
    contactCategoryTranslate (detail) {
      if (detail.categoryType && this.$te(`tenancy.history.categoryType.${detail.categoryType}`)) {
        return this.$t(`tenancy.history.categoryType.${detail.categoryType}`)
      } else {
        return detail.category || this.emptyValue
      }
    },
    async updateHistories () {
      if (this.sourceTable) {
        this.histories = await getBySourceIdAndSourceTable(this.sourceId, this.sourceTable)
      } else {
        this.histories = []
      }
      EventBus.$emit('tenancy.contacts.updateHistories', this.histories)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-header {
  margin-bottom: 15px
}
.update-histories {
  &__content {
    max-height: 600px;
    overflow: auto;
  }
}
table {
  margin: 0;
}
.table-content {
  max-height: 600px;
  overflow-y: auto;
  table {
    table-layout: fixed;
  }
}
</style>
